"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedStateDomain = exports.domainKey = void 0;
const effector_1 = require("effector");
const createDomainFallback = () => {
    console.error('Effector root domain not found');
    return (0, effector_1.createDomain)('rootDomain');
};
const rootDomain = ((_a = window === null || window === void 0 ? void 0 : window.effectorVars) === null || _a === void 0 ? void 0 : _a.rootDomain) || createDomainFallback();
exports.domainKey = 'sharedState';
exports.sharedStateDomain = rootDomain.createDomain(exports.domainKey);
